import React from "react"

export default () => (
  <React.Fragment>
    <h3>Ramona stuff</h3>
    <div>
      <a href='https://neilyoungarchives.com/movie-night'>
        Neil Young - Barnyard Session
      </a>
    </div>
  </React.Fragment>
)



// WEBPACK FOOTER //
// ./src/pages/index.js